import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useCookie } from 'react-use';
import { me, User } from './api';

export const useProfile = () => {
  const [profile, setProfile] = useState<Partial<User> | null>(null);
  const [cookie, setCookie, removeCookie] = useCookie('jwt');
  const [loaded, setLoaded] = useState(false);
  const query = useQuery('profile', me, {
    enabled: true,
    retry: false,
    onSuccess: (a) => {
      setProfile(a.data);
    },
    onError: (err) => {
      removeCookie();
      setProfile(null);
    },
    onSettled: () => {
      setLoaded(true);
    },
  });

  useEffect(() => {
    if (cookie) {
      setLoaded(false);
      query.refetch();
    }
  }, [cookie]);

  const logout = () => {
    removeCookie();
    setProfile(null);
    query.refetch();
  };

  return {
    profile,
    logout,
    isLoading: !loaded,
  };
};
